import * as R from 'ramda'
import mergeDeep from 'coact/utils/mergeDeep'
import toSchemaPath from 'coact/utils/schema/toSchemaPath'

import { reqData } from '../../../purchaseReq/index.js'
import $arrivalProcessData from '../../../arrivalProcess/dataAccess/index.js'

const schema = mergeDeep(
  R.pipe(
    R.assocPath(
      toSchemaPath('items.0.unarrivedQty'),
      $arrivalProcessData.schema.unarrivedQty,
    ),
    R.assocPath(
      toSchemaPath('items.0.onTheWayQty'),
      $arrivalProcessData.schema.onTheWayQty,
    ),
  )({}),
  reqData.schema,
)

export default schema
